import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import PageMetaData from "../../CustomComponents/PageMetaData/PageMetaData";
import "./SingleHotel.css";
import Skeleton from "react-loading-skeleton";
import SimilarHotels from "../../CustomComponents/SimilarHotels/SimilarHotels";
import OgMetaTitles from "../../CustomComponents/PageMetaData/OgMetaTitles";
import GetDirectionRedirect from "../../CustomComponents/GetDirectionRedirect/GetDirectionRedirect";
import { animateScroll as scroll } from "react-scroll";
import imgNotFound from "../../assets/images/single-image.png";
import NewUiHeader from "../../CustomComponents/NewComponents/NewUIHeader/NewUIHeader";
import styles from "./NewUISingleHotel.module.scss";
import EditNewUiSearchFormHotels from "../../CustomComponents/NewComponents/NewUiSearchForm/NewUiSearchFormHotels/EditNewUiSearchFormHotels";
import NewUISingleHotelRoomCard from "../../CustomComponents/NewComponents/NewUiHotels/NewUISIngleHotelRoomCard";
import { formatIndianCurrency } from "../../utils/utils";
import NewFooterUI from "../../CustomComponents/NewComponents/NewFooterUI/NewFooterUI";
import NewSingleHotelSearchForm from "../../CustomComponents/NewComponents/NewUiSearchForm/NewUiSearchFormHotels/NewSingleHotelSearchForm";

function SingleHotel() {
  const location = useLocation();
  const navigate = useNavigate();
  const [bookingData, setBookingData] = useState({});
  const [hotelData, setHotelData] = useState({});
  const { slug, id: hotelId } = useParams();
  const [loader, setLoader] = useState(true);
  // console.log(hotelData, "hotelLocation");

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const agentDiscount = userDetails?.agent_category_discount || 0;
  const agentDiscountType = userDetails?.agent_discount_type || "percentage";

  // console.log(agentDiscount);

  // const { item: currentHotel } = location?.state || {};
  // const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 9;

  Fancybox.bind("[data-fancybox]", {
    // Fancybox options if any
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(
  //   () => {
  //     const params = new URLSearchParams(location.search);

  //     // if (
  //     //   !params.has("hotelId") ||
  //     //   params.get("hotelId") === "" ||
  //     //   !params.has("location") ||
  //     //   params.get("location") === "" ||
  //     //   !params.has("room") ||
  //     //   params.get("room") === "" ||
  //     //   !params.has("adult") ||
  //     //   params.get("adult") === "" ||
  //     //   !params.has("checkinDay") ||
  //     //   params.get("checkinDay") === "" ||
  //     //   !params.has("checkinMonth") ||
  //     //   params.get("checkinMonth") === "" ||
  //     //   !params.has("checkinYear") ||
  //     //   params.get("checkinYear") === "" ||
  //     //   !params.has("checkoutDay") ||
  //     //   params.get("checkoutDay") === "" ||
  //     //   !params.has("checkoutMonth") ||
  //     //   params.get("checkoutMonth") === "" ||
  //     //   !params.has("checkoutYear") ||
  //     //   params.get("checkoutYear") === ""
  //     // ) {
  //     //   navigate("/");
  //     //   return;
  //     // }

  //     // Get the childAge parameters
  //     const childAges = [];
  //     let i = 1;
  //     while (params.has(`childAge[${i}]`)) {
  //       childAges.push(params.get(`childAge[${i}]`));
  //       i++;
  //     }

  //     const data = {
  //       slug,
  //       hotelId,
  //       location: params.get("location"),
  //       room: params.get("room"),
  //       adult: params.get("adult"),
  //       children: params.get("children"),
  //       checkinDay: params.get("checkinDay"),
  //       checkinMonth: params.get("checkinMonth"),
  //       checkinYear: params.get("checkinYear"),
  //       checkoutDay: params.get("checkoutDay"),
  //       checkoutMonth: params.get("checkoutMonth"),
  //       checkoutYear: params.get("checkoutYear"),
  //       hotel_name: params.get("hotel_name"),
  //       hotel_address: params.get("hotel_address"),
  //     };
  //     console.log("hotelId", hotelId);

  //     setBookingData(data);
  //     postBookingData(data);
  //   },
  //   [location.search],
  //   navigate
  // );

  // const postBookingData = async (data) => {
  //   setLoader(true);
  //   const myHeaders = new Headers();
  //   myHeaders.append("Accept", "application/json");
  //   myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);

  //   const checkInDate = `${data.checkinYear}-${String(
  //     data.checkinMonth
  //   ).padStart(2, "0")}-${String(data.checkinDay).padStart(2, "0")}`;
  //   const checkOutDate = `${data.checkoutYear}-${String(
  //     data.checkoutMonth
  //   ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

  //   const formdata = new FormData();
  //   formdata.append("checkIn", checkInDate);
  //   formdata.append("checkOut", checkOutDate);
  //   formdata.append("adults", data.adult);
  //   formdata.append("child", data.children);
  //   // formdata.append("location", data.location);
  //   formdata.append("rooms", data.room);
  //   formdata.append("PropertyType", "hotel");
  //   formdata.append("hotel_name", data.hotel_name);
  //   formdata.append("slug", data.slug);
  //   formdata.append("hotelId", data.hotelId);
  //   // formdata.append("hotel_slug", "golden-fern-resort-by-eco-hospitality");

  //   if (Array.isArray(data.childAge) && data.childAge.length > 0) {
  //     for (let i = 1; i <= data.childAge.length; i++) {
  //       formdata.append(`childAge[${i}]`, data.childAge[i - 1]);
  //     }
  //   }

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: formdata,
  //     redirect: "follow",
  //   };

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/api/v1/hotel-engine/check-availability`,
  //       requestOptions
  //     );

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }

  //     const result = await response.json();
  //     setHotelData(result.data);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     // Handle error state or retry logic if needed
  //   } finally {
  //     setLoader(false);
  //   }
  // };
  const today = new Date();

  const tomorrow = new Date(today); // Clone 'today' instead of modifying it
  tomorrow.setDate(tomorrow.getDate() + 1);

  // Extract date parts
  const checkinDay = today.getDate();
  const checkinMonth = today.getMonth() + 1; // Month is 0-indexed
  const checkinYear = today.getFullYear();

  const checkoutDay = tomorrow.getDate();
  const checkoutMonth = tomorrow.getMonth() + 1;
  const checkoutYear = tomorrow.getFullYear();

  // console.log(bookingData, "bookingData");

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    if (!slug || !hotelId) {
      // Optional fallback UI or message
      console.warn("Missing slug or hotelId, skipping fetch.");
      return;
    }

    const data = {
      slug,
      hotelId,
      location: params.get("location") || "",
      room: params.get("room") || "1",
      adult: params.get("adult") || "2",
      children: params.get("children") || "0",
      checkinDay: params.get("checkinDay") || checkinDay,
      checkinMonth: params.get("checkinMonth") || checkinMonth,
      checkinYear: params.get("checkinYear") || checkinYear,
      checkoutDay: params.get("checkoutDay") || checkoutDay,
      checkoutMonth: params.get("checkoutMonth") || checkoutMonth,
      checkoutYear: params.get("checkoutYear") || checkoutYear,
      hotel_name: params.get("hotel_name") || "",
      hotel_address: params.get("hotel_address") || "",
      childAge: childAges,
    };

    setBookingData(data);
    postBookingData(data);
  }, [location.search, slug, hotelId]);

  const postBookingData = async (data) => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);

    const checkInDate = `${data.checkinYear}-${String(
      data.checkinMonth
    ).padStart(2, "0")}-${String(data.checkinDay).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    const formdata = new FormData();
    formdata.append("checkIn", checkInDate);
    formdata.append("checkOut", checkOutDate);
    formdata.append("adults", data.adult);
    formdata.append("child", data.children);
    formdata.append("rooms", data.room);
    formdata.append("PropertyType", "hotel");
    formdata.append("hotel_name", data.hotel_name);
    formdata.append("slug", data.slug);
    formdata.append("hotelId", data.hotelId);
    // formdata.append("location", data.location);

    if (Array.isArray(data.childAge) && data.childAge.length > 0) {
      data.childAge.forEach((age, index) => {
        formdata.append(`childAge[${index + 1}]`, age);
      });
    }

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/hotel-engine/check-availability`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setHotelData(result.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  const [hotelAmenities, setHotelAmenities] = useState(false);
  const firstRoom = hotelData?.rooms?.[0];
  const firstMealPlan = firstRoom?.rates?.[0];
  const hotelAddress = hotelData?.hotelInfo?.address
    ? `${hotelData?.hotelInfo?.name}, ${hotelData?.hotelInfo?.address}, ${hotelData?.hotelInfo?.city}, ${hotelData?.hotelInfo?.state}, ${hotelData?.hotelInfo?.country}`
    : "";

  const encodedAddress = hotelAddress ? encodeURIComponent(hotelAddress) : "";

  const mapSrc = `https://www.google.com/maps?q=${encodedAddress}&output=embed`;

  const [filter, setFilter] = useState("RoomDetails");
  const [activeFilter, setActiveFilter] = useState("RoomDetails");
  const [showAllTabs, setShowAllTabs] = useState(false);

  const handleTabClick = (value) => {
    if (value === "overview") {
      setShowAllTabs(!showAllTabs); // Toggle visibility of other tabs
    }
    setActiveFilter(value);
  };

  const mainFilters = [
    { label: "Rooms & Suites", value: "RoomDetails" },
    { label: "Amenities", value: "HotelAmenities" },
    { label: "About", value: "HotelAbout" },
    { label: "Hotel Location", value: "HotelLocation" },
    { label: "Similar Hotels", value: "SimilarHotels" },
  ];

  // const handleScrollToSection = (sectionValue) => {
  //   setFilter(sectionValue);
  //   document
  //     .getElementById(sectionValue)
  //     ?.scrollIntoView({ behavior: "smooth" });
  //   setShowAllTabs(false);
  // };

  const handleScrollToSection = (sectionValue) => {
    setFilter(sectionValue);

    const section = document.getElementById(sectionValue);
    if (section) {
      const headerHeight =
        document.querySelector("#NewUIHeader")?.offsetHeight || 0;
      const searchFormHeight =
        document.querySelector("#HotelEditSearchForm")?.offsetHeight || 0;
      const totalOffset = headerHeight + searchFormHeight + 44; // Adding extra spacing

      const sectionPosition =
        section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionPosition - totalOffset,
        behavior: "smooth",
      });
    }

    setShowAllTabs(false);
  };

  const queryParams = new URLSearchParams(location.search);

  // const roomsData = JSON.parse(
  //   decodeURIComponent(queryParams.get("roomsData"))
  // );

  // console.log("roomsData", roomsData);

  const [roomsData, setRoomsData] = useState("");

  const handleRoomsChange = (updatedRooms) => {
    setRoomsData(updatedRooms);
  };

  return (
    <>
      {/* <PageMetaData
        title={`${
          hotelData?.hotelInfo?.name &&
          hotelData?.hotelInfo?.name !== "" &&
          hotelData?.hotelInfo?.name !== undefined &&
          hotelData?.hotelInfo?.name
        } - Mountain Mysteries`}
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      /> */}
      <PageMetaData
        title={`${
          hotelData?.hotelInfo?.metadata?.meta_title
            ? hotelData.hotelInfo?.metadata.meta_title
            : hotelData?.hotelInfo?.name || ""
        } `}
        description={
          hotelData?.hotelInfo?.metadata?.meta_description
            ? hotelData?.hotelInfo?.metadata.meta_description
            : ""
        }
        keywords={
          hotelData?.hotelInfo?.metadata?.meta_keywords
            ? hotelData?.hotelInfo?.metadata.meta_keywords
            : ""
        }
      />

      <OgMetaTitles
        title={`${
          hotelData?.hotelInfo?.name &&
          hotelData?.hotelInfo?.name !== "" &&
          hotelData?.hotelInfo?.name !== undefined &&
          hotelData?.hotelInfo?.name
        } - Mountain Mysteries`}
        type="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        url={`https://www.mountainmysteries.com/single-hotel/${bookingData?.hotelId}?hotelId=${bookingData?.hotelId}&location=$${bookingData?.location}&room=${bookingData?.room}&adult=${bookingData?.adult}&children=0&&checkinDay=5&checkinMonth=10&checkinYear=2024&checkoutDay=6&checkoutMonth=10&checkoutYear=2024&hotel_name=Shimla%20Havens%20Resort&hotel_address=Shimla`}
      />

      <NewUiHeader />
      <NewSingleHotelSearchForm
        searchType="single_hotel"
        singleHotelPage={true}
        singleHotelData={bookingData}
        handleRoomsChange={handleRoomsChange}
      />

      {loader ? (
        <div className="container">
          <div className="overview-content loading-filter-main">
            <h4 className="SingleHotel-Name">
              <b>
                <Skeleton width={100} />
              </b>
            </h4>
            <small>
              <Skeleton width={400} />
            </small>
            <p className="SingleHotel-description mb-20">
              <Skeleton width={200} />
              {/* <Skeleton width={700} /> */}
              {/* <Skeleton width={500} /> */}
            </p>

            {Array.from({ length: 1 }).map((_, index) => (
              <div className="gallery" key={index}>
                <div>
                  <Skeleton height={350} />
                </div>
                <div className="gallery2">
                  <div>
                    <Skeleton height={170} />
                  </div>
                  <div className="SingleHotel-gallary-sm">
                    <Skeleton height={170} />
                  </div>
                  <div className="SingleHotel-gallary-sm">
                    <Skeleton height={170} />
                  </div>
                  <div className="SingleHotel-gallary-sm">
                    <Skeleton height={170} />
                  </div>
                </div>
              </div>
            ))}

            {Array.from({ length: 5 }).map((_, index) => {
              return (
                <div className="single-room-card" key={index}>
                  <div
                    className="card_head flex"
                    style={{
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div className="agent">
                      <h4>
                        <Skeleton width={400} />
                      </h4>
                      <div className="flex flex_gap_10">
                        <Skeleton />
                      </div>
                    </div>
                    <div>
                      <Skeleton width={200} />
                    </div>
                  </div>

                  <div className="single_room_data_">
                    <div className="hotel_view_img">
                      <Skeleton height={185} />
                    </div>

                    <div className="rooms_content">
                      {Array.from({ length: 3 }).map((_, index) => {
                        return (
                          <div
                            className="single_room_details"
                            style={{ padding: "6px 18px" }}
                            key={index}
                          >
                            <div>
                              <p>
                                <small>
                                  <Skeleton width={200} />
                                </small>
                              </p>
                              <p>
                                <small>
                                  <Skeleton width={200} />
                                </small>
                              </p>
                            </div>
                            <div className="single_room_price">
                              <div>
                                <h4>
                                  <Skeleton width={100} />
                                </h4>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="loading-filter-responsive">
            {Array.from({ length: 1 }).map((_, index) => (
              <div className="gallery" key={index}>
                <div>
                  <Skeleton height={150} />
                </div>
                <div className="gallery2">
                  <div>
                    <Skeleton height={70} />
                  </div>
                  <div className="SingleHotel-gallary-sm">
                    <Skeleton height={70} />
                  </div>
                  <div className="SingleHotel-gallary-sm">
                    <Skeleton height={70} />
                  </div>
                  <div className="SingleHotel-gallary-sm">
                    <Skeleton height={70} />
                  </div>
                </div>
              </div>
            ))}
            <h4 className="SingleHotel-Name">
              <b>
                <Skeleton width={250} />
              </b>
            </h4>
            <small>
              <Skeleton width={180} />
            </small>
            <p className="SingleHotel-description mb-20">
              <Skeleton width={900} />
              <Skeleton width={700} />
              <Skeleton width={500} />
              <Skeleton width={300} />
              <Skeleton width={100} />
            </p>
          </div>
        </div>
      ) : (
        <section className="new_ui_bg">
          <div className={styles.SingleHotelPage}>
            <div className={styles.outer_container}>
              <div className={styles.SingleHotelPageInfo}>
                <div className={styles.Rating}>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 0.5L8.5716 5.33688H13.6574L9.5429 8.32624L11.1145 13.1631L7 10.1738L2.8855 13.1631L4.4571 8.32624L0.342604 5.33688H5.4284L7 0.5Z"
                      fill="#ECB119"
                    />
                  </svg>
                  {hotelData?.hotelInfo?.star_rating
                    ? Number(hotelData?.hotelInfo?.star_rating)
                    : 0}{" "}
                  Star
                </div>
                <h4>{hotelData?.hotelInfo?.name}</h4>
                <GetDirectionRedirect address={hotelData?.hotelInfo?.address}>
                  <small>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.83301 6.66667C4.83301 5.82681 5.16664 5.02136 5.7605 4.4275C6.35437 3.83363 7.15982 3.5 7.99967 3.5C8.83953 3.5 9.64498 3.83363 10.2388 4.4275C10.8327 5.02136 11.1663 5.82681 11.1663 6.66667C11.1663 7.50652 10.8327 8.31197 10.2388 8.90584C9.64498 9.4997 8.83953 9.83333 7.99967 9.83333C7.15982 9.83333 6.35437 9.4997 5.7605 8.90584C5.16664 8.31197 4.83301 7.50652 4.83301 6.66667ZM7.99967 4.5C7.42504 4.5 6.87394 4.72827 6.46761 5.1346C6.06128 5.54093 5.83301 6.09203 5.83301 6.66667C5.83301 7.2413 6.06128 7.7924 6.46761 8.19873C6.87394 8.60506 7.42504 8.83333 7.99967 8.83333C8.57431 8.83333 9.12541 8.60506 9.53174 8.19873C9.93807 7.7924 10.1663 7.2413 10.1663 6.66667C10.1663 6.09203 9.93807 5.54093 9.53174 5.1346C9.12541 4.72827 8.57431 4.5 7.99967 4.5Z"
                        fill="#888888"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.34926 5.90471C2.46321 4.52258 3.09274 3.23383 4.11287 2.29436C5.13299 1.35488 6.4691 0.83337 7.85593 0.833374H8.14393C9.53075 0.83337 10.8669 1.35488 11.887 2.29436C12.9071 3.23383 13.5366 4.52258 13.6506 5.90471C13.7774 7.44423 13.3018 8.97288 12.3239 10.1687L9.12859 14.076C8.99185 14.2433 8.81965 14.378 8.62445 14.4705C8.42926 14.5631 8.21594 14.6111 7.99993 14.6111C7.78391 14.6111 7.57059 14.5631 7.3754 14.4705C7.1802 14.378 7.00801 14.2433 6.87126 14.076L3.67593 10.1687C2.698 8.97292 2.22238 7.44424 2.34926 5.90471ZM7.85593 1.83337C6.72025 1.83355 5.62615 2.26073 4.79081 3.03012C3.95546 3.79952 3.43995 4.85487 3.34659 5.98671C3.24099 7.26795 3.63678 8.54016 4.45059 9.53537L7.64593 13.4434C7.68888 13.4959 7.74298 13.5383 7.80432 13.5674C7.86566 13.5965 7.9327 13.6116 8.00059 13.6116C8.06848 13.6116 8.13552 13.5965 8.19686 13.5674C8.2582 13.5383 8.3123 13.4959 8.35526 13.4434L11.5506 9.53537C12.3639 8.53997 12.7592 7.26777 12.6533 5.98671C12.5599 4.85476 12.0443 3.79931 11.2088 3.02989C10.3733 2.26048 9.27905 1.83338 8.14326 1.83337H7.85526H7.85593Z"
                        fill="#888888"
                      />
                    </svg>
                    {hotelData?.hotelInfo?.address}
                  </small>
                </GetDirectionRedirect>
              </div>

              {hotelData && hotelData.hotelImages && (
                <div className={styles.SingleHotelPageGallery}>
                  {hotelData?.hotelImages && (
                    <div className={styles.gallery}>
                      <div className={styles.gallery1}>
                        <img
                          src={
                            hotelData?.hotelImages[0]
                              ? hotelData?.hotelImages[0]
                              : imgNotFound
                          }
                          alt="hotel-image"
                        />
                        {hotelData?.hotelImages?.length > 1 && (
                          <button
                            className={styles.images_btn}
                            onClick={() => {
                              Fancybox.show(
                                hotelData?.hotelImages?.map((src) => ({
                                  src,
                                  type: "image",
                                }))
                              );
                            }}
                          >
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 16 15"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M8 11.625C8.9375 11.625 9.73438 11.2969 10.3906 10.6406C11.0469 9.98438 11.375 9.1875 11.375 8.25C11.375 7.3125 11.0469 6.51562 10.3906 5.85938C9.73438 5.20312 8.9375 4.875 8 4.875C7.0625 4.875 6.26562 5.20312 5.60938 5.85938C4.95312 6.51562 4.625 7.3125 4.625 8.25C4.625 9.1875 4.95312 9.98438 5.60938 10.6406C6.26562 11.2969 7.0625 11.625 8 11.625ZM8 10.125C7.475 10.125 7.03125 9.94375 6.66875 9.58125C6.30625 9.21875 6.125 8.775 6.125 8.25C6.125 7.725 6.30625 7.28125 6.66875 6.91875C7.03125 6.55625 7.475 6.375 8 6.375C8.525 6.375 8.96875 6.55625 9.33125 6.91875C9.69375 7.28125 9.875 7.725 9.875 8.25C9.875 8.775 9.69375 9.21875 9.33125 9.58125C8.96875 9.94375 8.525 10.125 8 10.125ZM2 14.25C1.5875 14.25 1.23438 14.1031 0.940625 13.8094C0.646875 13.5156 0.5 13.1625 0.5 12.75V3.75C0.5 3.3375 0.646875 2.98438 0.940625 2.69063C1.23438 2.39688 1.5875 2.25 2 2.25H4.3625L5.75 0.75H10.25L11.6375 2.25H14C14.4125 2.25 14.7656 2.39688 15.0594 2.69063C15.3531 2.98438 15.5 3.3375 15.5 3.75V12.75C15.5 13.1625 15.3531 13.5156 15.0594 13.8094C14.7656 14.1031 14.4125 14.25 14 14.25H2ZM2 12.75H14V3.75H10.9625L9.59375 2.25H6.40625L5.0375 3.75H2V12.75Z" />
                            </svg>
                            See all images
                          </button>
                        )}
                      </div>
                      <div className={styles.gallery2}>
                        <div>
                          <img
                            src={
                              hotelData?.hotelImages[1]
                                ? hotelData?.hotelImages[1]
                                : imgNotFound
                            }
                            alt="hotel-image"
                          />
                        </div>
                        <div className="SingleHotel-gallary-sm">
                          <img
                            src={
                              hotelData?.hotelImages[2]
                                ? hotelData?.hotelImages[2]
                                : imgNotFound
                            }
                            alt="hotel-image"
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div className={styles.package_highlights}>
                    {/* Best Deal Tag */}
                    <div className={styles.package_highlights_heading}>
                      BEST DEAL
                    </div>

                    <div className="flex justify_content_between mt-10 mb-10">
                      <div>
                        <h4 className={styles.room_title}>
                          {firstRoom?.room_name}
                        </h4>
                        {firstMealPlan?.meal_plan_name && (
                          <p className={styles.room_type}>
                            {firstMealPlan.meal_plan_name}
                          </p>
                        )}
                      </div>
                      <div className={styles.price_section}>
                        {firstMealPlan?.rate_per_night ? (
                          <span className={styles.price}>
                            {formatIndianCurrency(firstMealPlan.rate_per_night)}
                          </span>
                        ) : (
                          <span className={styles.price}>N/A</span> // Default if not available
                        )}
                        <span className={styles.tax}>+Tax</span>
                      </div>
                    </div>
                    <div className="flex justify_content_between mt-10">
                      <div className={styles.room_info}>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <mask
                              id="mask0_6067_10697"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="16"
                              height="16"
                            >
                              <rect width="16" height="16" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_6067_10697)">
                              <path
                                d="M8 7.7946C7.35833 7.7946 6.80906 7.56615 6.35217 7.10926C5.89517 6.65226 5.66667 6.10293 5.66667 5.46126C5.66667 4.8196 5.89517 4.27032 6.35217 3.81343C6.80906 3.35643 7.35833 3.12793 8 3.12793C8.64167 3.12793 9.19094 3.35643 9.64783 3.81343C10.1048 4.27032 10.3333 4.8196 10.3333 5.46126C10.3333 6.10293 10.1048 6.65226 9.64783 7.10926C9.19094 7.56615 8.64167 7.7946 8 7.7946ZM3 11.8588V11.3894C3 11.063 3.08867 10.7607 3.266 10.4824C3.44333 10.2042 3.68033 9.99032 3.977 9.84076C4.63589 9.51776 5.30061 9.27549 5.97117 9.11393C6.64172 8.95237 7.318 8.8716 8 8.8716C8.682 8.8716 9.35828 8.95237 10.0288 9.11393C10.6994 9.27549 11.3641 9.51776 12.023 9.84076C12.3197 9.99032 12.5567 10.2042 12.734 10.4824C12.9113 10.7607 13 11.063 13 11.3894V11.8588C13 12.1399 12.9015 12.379 12.7045 12.5761C12.5075 12.7731 12.2684 12.8716 11.9872 12.8716H4.01283C3.73161 12.8716 3.4925 12.7731 3.2955 12.5761C3.0985 12.379 3 12.1399 3 11.8588ZM4 11.8716H12V11.3894C12 11.2544 11.9609 11.1294 11.8827 11.0144C11.8044 10.8995 11.6983 10.8058 11.5642 10.7331C10.9897 10.4502 10.4041 10.2359 9.80717 10.0901C9.21017 9.94443 8.60778 9.8716 8 9.8716C7.39222 9.8716 6.78983 9.94443 6.19283 10.0901C5.59594 10.2359 5.01028 10.4502 4.43583 10.7331C4.30172 10.8058 4.19556 10.8995 4.11733 11.0144C4.03911 11.1294 4 11.2544 4 11.3894V11.8716ZM8 6.7946C8.36667 6.7946 8.68056 6.66404 8.94167 6.40293C9.20278 6.14182 9.33333 5.82793 9.33333 5.46126C9.33333 5.0946 9.20278 4.78071 8.94167 4.5196C8.68056 4.25849 8.36667 4.12793 8 4.12793C7.63333 4.12793 7.31944 4.25849 7.05833 4.5196C6.79722 4.78071 6.66667 5.0946 6.66667 5.46126C6.66667 5.82793 6.79722 6.14182 7.05833 6.40293C7.31944 6.66404 7.63333 6.7946 8 6.7946Z"
                                fill="#666666"
                              />
                            </g>
                          </svg>{" "}
                          2 Guests
                        </span>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <mask
                              id="mask0_6067_10703"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="16"
                              height="16"
                            >
                              <rect width="16" height="16" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_6067_10703)">
                              <path
                                d="M5 9.923H11V10.6282C11 10.7128 11.028 10.7832 11.084 10.8392C11.14 10.8951 11.2103 10.923 11.2948 10.923C11.3795 10.923 11.4498 10.8951 11.5058 10.8392C11.5617 10.7832 11.5897 10.7128 11.5897 10.6282V8.541C11.5897 8.24189 11.4959 7.98956 11.3083 7.784C11.1208 7.57844 10.8812 7.46156 10.5897 7.43333V6.56417C10.5897 6.25728 10.4869 6.00106 10.2813 5.7955C10.0758 5.58994 9.81961 5.48717 9.51283 5.48717H6.48717C6.18039 5.48717 5.92422 5.58994 5.71867 5.7955C5.51311 6.00106 5.41033 6.25728 5.41033 6.56417V7.43333C5.11878 7.46156 4.87922 7.57844 4.69167 7.784C4.50411 7.98956 4.41033 8.24189 4.41033 8.541V10.6282C4.41033 10.7128 4.43828 10.7832 4.49417 10.8392C4.55017 10.8951 4.6205 10.923 4.70517 10.923C4.78972 10.923 4.86 10.8951 4.916 10.8392C4.972 10.7832 5 10.7128 5 10.6282V9.923ZM5 9.33333V8.541C5 8.38544 5.05128 8.25639 5.15383 8.15383C5.25639 8.05128 5.38544 8 5.541 8H10.459C10.6146 8 10.7436 8.05128 10.8462 8.15383C10.9487 8.25639 11 8.38544 11 8.541V9.33333H5ZM6 7.41033V6.48717C6 6.3675 6.03844 6.26922 6.11533 6.19233C6.19233 6.11544 6.29067 6.077 6.41033 6.077H9.58967C9.70933 6.077 9.80767 6.11544 9.88467 6.19233C9.96156 6.26922 10 6.3675 10 6.48717V7.41033H6ZM3.077 14C2.77011 14 2.51389 13.8972 2.30833 13.6917C2.10278 13.4861 2 13.2299 2 12.923V3.077C2 2.77011 2.10278 2.51389 2.30833 2.30833C2.51389 2.10278 2.77011 2 3.077 2H12.923C13.2299 2 13.4861 2.10278 13.6917 2.30833C13.8972 2.51389 14 2.77011 14 3.077V12.923C14 13.2299 13.8972 13.4861 13.6917 13.6917C13.4861 13.8972 13.2299 14 12.923 14H3.077ZM3.077 13.3333H12.923C13.0257 13.3333 13.1197 13.2906 13.2052 13.2052C13.2906 13.1197 13.3333 13.0257 13.3333 12.923V3.077C13.3333 2.97433 13.2906 2.88028 13.2052 2.79483C13.1197 2.70939 13.0257 2.66667 12.923 2.66667H3.077C2.97433 2.66667 2.88028 2.70939 2.79483 2.79483C2.70939 2.88028 2.66667 2.97433 2.66667 3.077V12.923C2.66667 13.0257 2.70939 13.1197 2.79483 13.2052C2.88028 13.2906 2.97433 13.3333 3.077 13.3333Z"
                                fill="#333333"
                              />
                            </g>
                          </svg>{" "}
                          1 Room
                        </span>
                      </div>
                      {/* <a className={styles.price_details}>Price Details</a> */}
                    </div>

                    {/* Buttons */}
                    {/* <button className={styles.select_room}>SELECT THIS ROOM</button> */}
                    <a className={styles.view_options} href="#RoomDetails">
                      VIEW ALL OPTIONS
                    </a>
                  </div>
                </div>
              )}
            </div>

            <div className={`${styles.filter_section}`}>
              <div className={styles.container_inside}>
                <div className={styles.filter_wrapper}>
                  {mainFilters.map((item, index) => (
                    <div
                      key={index}
                      onClick={() => handleScrollToSection(item.value)}
                      className={`${styles.filter_card} ${
                        filter === item.value ? styles.active_filter : ""
                      }`}
                    >
                      {item.label}
                    </div>
                  ))}{" "}
                </div>
                <div className={styles.mobile_filter_wrapper}>
                  <div
                    onClick={() => handleTabClick("overview")}
                    className={`${
                      styles.filter_card
                    } flex align_items_center justify_content_center flex_gap_5 ${
                      activeFilter === "overview" ? styles.active_filter : ""
                    }`}
                  >
                    Overview{" "}
                    <svg
                      width="11"
                      height="8"
                      viewBox="0 0 13 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        transition: "transform 0.4s",
                        transform: showAllTabs
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      }}
                    >
                      <path
                        d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                        stroke="#009A50"
                        strokeWidth="1.5"
                      />
                    </svg>
                  </div>
                  {showAllTabs &&
                    mainFilters
                      .filter((item) => item.value !== "overview")
                      .map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleScrollToSection(item.value)}
                          className={`${styles.filter_card} ${
                            activeFilter === item.value
                              ? styles.active_filter
                              : ""
                          }`}
                        >
                          {item.label}{" "}
                        </div>
                      ))}
                </div>
              </div>
            </div>

            {/* <p className="font_12">{hotelData?.hotelInfo?.details}</p> */}
            {/* <SingleHotelCard
                rooms={hotelData}
                bookingData={bookingData}
                agentDiscount={agentDiscount}
              /> */}
            <div className="container">
              <div id="RoomDetails">
                <h4 className={styles.single_hotel_page_heading}>
                  Rooms & Suites
                </h4>
                <NewUISingleHotelRoomCard
                  rooms={hotelData}
                  bookingData={bookingData}
                  agentDiscount={agentDiscount}
                />
              </div>
              {hotelData?.hotelInfo?.hotel_amenities?.property_amenity?.length >
                0 && (
                <div id="HotelAmenities">
                  <div className={styles.single_hotel_white_wrapper_outer}>
                    <h4
                      className={styles.single_hotel_white_wrapper}
                      style={{
                        fontSize: "20px",
                        fontWeight: "500",
                        color: "#333",
                      }}
                    >
                      Amenities
                    </h4>
                    <ul className={`${styles.hotel_amenities} mt-10`}>
                      {hotelData?.hotelInfo?.hotel_amenities?.property_amenity
                        ?.length > 0 &&
                        hotelData.hotelInfo?.hotel_amenities.property_amenity.map(
                          (item, index) => (
                            <li key={index}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                                fill="none"
                              >
                                <mask
                                  id="mask0_5983_7981"
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="18"
                                  height="19"
                                >
                                  <rect
                                    y="0.500122"
                                    width="18"
                                    height="18"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_5983_7981)">
                                  <path
                                    d="M7.93605 11.1096L6.1938 9.36719C6.08993 9.26344 5.95936 9.21031 5.80211 9.20781C5.64499 9.20544 5.51205 9.25856 5.4033 9.36719C5.29468 9.47594 5.24036 9.60769 5.24036 9.76244C5.24036 9.91719 5.29468 10.0489 5.4033 10.1577L7.46149 12.2159C7.59711 12.3514 7.7553 12.4191 7.93605 12.4191C8.1168 12.4191 8.27499 12.3514 8.41061 12.2159L12.5832 8.04325C12.687 7.93938 12.7401 7.80881 12.7426 7.65156C12.745 7.49444 12.6919 7.3615 12.5832 7.25275C12.4745 7.14413 12.3427 7.08981 12.188 7.08981C12.0332 7.08981 11.9015 7.14413 11.7927 7.25275L7.93605 11.1096ZM9.0018 16.6249C8.0163 16.6249 7.08999 16.4379 6.22286 16.0639C5.35574 15.6899 4.60149 15.1824 3.96011 14.5413C3.31874 13.9001 2.81093 13.1462 2.43668 12.2794C2.06255 11.4127 1.87549 10.4866 1.87549 9.50125C1.87549 8.51575 2.06249 7.58944 2.43649 6.72231C2.81049 5.85519 3.31805 5.10094 3.95918 4.45956C4.6003 3.81819 5.35424 3.31038 6.22099 2.93613C7.08774 2.562 8.0138 2.37494 8.99918 2.37494C9.98468 2.37494 10.911 2.56194 11.7781 2.93594C12.6452 3.30994 13.3995 3.8175 14.0409 4.45863C14.6822 5.09975 15.1901 5.85369 15.5643 6.72044C15.9384 7.58719 16.1255 8.51325 16.1255 9.49863C16.1255 10.4841 15.9385 11.4104 15.5645 12.2776C15.1905 13.1447 14.6829 13.8989 14.0418 14.5403C13.4007 15.1817 12.6467 15.6895 11.78 16.0638C10.9132 16.4379 9.98718 16.6249 9.0018 16.6249ZM9.00049 15.4999C10.6755 15.4999 12.0942 14.9187 13.2567 13.7562C14.4192 12.5937 15.0005 11.1749 15.0005 9.49994C15.0005 7.82494 14.4192 6.40619 13.2567 5.24369C12.0942 4.08119 10.6755 3.49994 9.00049 3.49994C7.32549 3.49994 5.90674 4.08119 4.74424 5.24369C3.58174 6.40619 3.00049 7.82494 3.00049 9.49994C3.00049 11.1749 3.58174 12.5937 4.74424 13.7562C5.90674 14.9187 7.32549 15.4999 9.00049 15.4999Z"
                                    fill="#333333"
                                  />
                                </g>
                              </svg>
                              {item}
                            </li>
                          )
                        )}
                    </ul>
                  </div>
                </div>
              )}
              {hotelData?.hotelInfo?.content?.length > 0 && (
                <div id="HotelAbout">
                  <div className={styles.single_hotel_white_wrapper_outer}>
                    <h4 className={styles.single_hotel_page_heading}>
                      About Property
                    </h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: hotelData?.hotelInfo?.content,
                      }}
                    ></p>
                  </div>
                </div>
              )}
              {hotelAddress && hotelAddress?.length > 0 && (
                <div id="HotelLocation" className="pb_20">
                  <div className={styles.single_hotel_white_wrapper_outer}>
                    <h4 className={styles.single_hotel_page_heading}>
                      Location
                    </h4>
                    {hotelAddress ? (
                      <iframe
                        src={mapSrc}
                        width="100%"
                        height="350"
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                      ></iframe>
                    ) : (
                      <p>Location details not available</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      )}
      <div id="SimilarHotels">
        <SimilarHotels
          filterId={bookingData?.hotelId}
          hotelLocation={hotelData?.hotelInfo?.city}
        />
      </div>

      <NewFooterUI />

      {/* 
     <PageLinks links={["Home", `Properties In ${bookingData.location}`, `${bookingData.hotel_name}`]} />
      <SingleSearchForm />
      <Header />
      <SingleSearchForm
        searchType="hotel_listing"
        singleHotelPage={true}
        singleHotelData={bookingData}
      />
      <Footer /> */}
    </>
  );
}

export default SingleHotel;

{
  /* <div className="container">
            <div className="overview-content">
              <div className="flex flex_gap_10 align_items_center mt-20">
                <div
                  onClick={() =>
                    // navigate(
                    //   `/listing-hotels?hotelID=${bookingData?.hotelId}&location=${bookingData?.location}&room=${bookingData?.room}&adult=${bookingData?.adult}&children=${bookingData?.children}&checkinDay=16&checkinMonth=10&checkinYear=2024&checkoutDay=17&checkoutMonth=10&checkoutYear=2024&room=1&adult=2&children=0&radio=s`
                    // )
                    navigate(-1)
                  }
                  style={{
                    background: "#cccccc7e",
                    padding: "5px 10px 10px",
                    borderRadius: "6px",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 9H16V7H1V9Z"
                      fill="#333333"
                    ></path>
                  </svg>
                </div>{" "}
                <h4 className="flex align_items_center flex_gap_20">
                  {hotelData?.hotelInfo?.name}
                </h4>
              </div>
              {hotelData && hotelData.hotelImages && (
                <>
                  <div className="gallery">
                    <div>
                      <img
                        src={
                          hotelData.hotelImages[0]
                            ? hotelData.hotelImages[0]
                            : imgNotFound
                        }
                        alt="hotel-image"
                      />
                      {hotelData?.hotelImages?.length > 1 && (
                        <div>
                          <button
                            className="images_btn"
                            onClick={() => {
                              Fancybox.show(
                                hotelData?.hotelImages?.map((src) => ({
                                  src,
                                  type: "image",
                                }))
                              );
                            }}
                          >
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 16 15"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M8 11.625C8.9375 11.625 9.73438 11.2969 10.3906 10.6406C11.0469 9.98438 11.375 9.1875 11.375 8.25C11.375 7.3125 11.0469 6.51562 10.3906 5.85938C9.73438 5.20312 8.9375 4.875 8 4.875C7.0625 4.875 6.26562 5.20312 5.60938 5.85938C4.95312 6.51562 4.625 7.3125 4.625 8.25C4.625 9.1875 4.95312 9.98438 5.60938 10.6406C6.26562 11.2969 7.0625 11.625 8 11.625ZM8 10.125C7.475 10.125 7.03125 9.94375 6.66875 9.58125C6.30625 9.21875 6.125 8.775 6.125 8.25C6.125 7.725 6.30625 7.28125 6.66875 6.91875C7.03125 6.55625 7.475 6.375 8 6.375C8.525 6.375 8.96875 6.55625 9.33125 6.91875C9.69375 7.28125 9.875 7.725 9.875 8.25C9.875 8.775 9.69375 9.21875 9.33125 9.58125C8.96875 9.94375 8.525 10.125 8 10.125ZM2 14.25C1.5875 14.25 1.23438 14.1031 0.940625 13.8094C0.646875 13.5156 0.5 13.1625 0.5 12.75V3.75C0.5 3.3375 0.646875 2.98438 0.940625 2.69063C1.23438 2.39688 1.5875 2.25 2 2.25H4.3625L5.75 0.75H10.25L11.6375 2.25H14C14.4125 2.25 14.7656 2.39688 15.0594 2.69063C15.3531 2.98438 15.5 3.3375 15.5 3.75V12.75C15.5 13.1625 15.3531 13.5156 15.0594 13.8094C14.7656 14.1031 14.4125 14.25 14 14.25H2ZM2 12.75H14V3.75H10.9625L9.59375 2.25H6.40625L5.0375 3.75H2V12.75Z" />
                            </svg>
                            See all images
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="gallery2">
                      <div>
                        <img
                          src={
                            hotelData.hotelImages[1]
                              ? hotelData.hotelImages[1]
                              : imgNotFound
                          }
                          alt="hotel-image"
                        />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <img
                          src={
                            hotelData.hotelImages[2]
                              ? hotelData.hotelImages[2]
                              : imgNotFound
                          }
                          alt="hotel-image"
                        />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <img
                          src={
                            hotelData.hotelImages[3]
                              ? hotelData.hotelImages[3]
                              : imgNotFound
                          }
                          alt="hotel-image"
                        />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <img
                          src={
                            hotelData.hotelImages[4]
                              ? hotelData.hotelImages[4]
                              : imgNotFound
                          }
                          alt="hotel-image"
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              <GetDirectionRedirect address={hotelData?.hotelInfo?.address}>
                <small>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4.83301 6.66667C4.83301 5.82681 5.16664 5.02136 5.7605 4.4275C6.35437 3.83363 7.15982 3.5 7.99967 3.5C8.83953 3.5 9.64498 3.83363 10.2388 4.4275C10.8327 5.02136 11.1663 5.82681 11.1663 6.66667C11.1663 7.50652 10.8327 8.31197 10.2388 8.90584C9.64498 9.4997 8.83953 9.83333 7.99967 9.83333C7.15982 9.83333 6.35437 9.4997 5.7605 8.90584C5.16664 8.31197 4.83301 7.50652 4.83301 6.66667ZM7.99967 4.5C7.42504 4.5 6.87394 4.72827 6.46761 5.1346C6.06128 5.54093 5.83301 6.09203 5.83301 6.66667C5.83301 7.2413 6.06128 7.7924 6.46761 8.19873C6.87394 8.60506 7.42504 8.83333 7.99967 8.83333C8.57431 8.83333 9.12541 8.60506 9.53174 8.19873C9.93807 7.7924 10.1663 7.2413 10.1663 6.66667C10.1663 6.09203 9.93807 5.54093 9.53174 5.1346C9.12541 4.72827 8.57431 4.5 7.99967 4.5Z"
                      fill="#888888"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M2.34926 5.90471C2.46321 4.52258 3.09274 3.23383 4.11287 2.29436C5.13299 1.35488 6.4691 0.83337 7.85593 0.833374H8.14393C9.53075 0.83337 10.8669 1.35488 11.887 2.29436C12.9071 3.23383 13.5366 4.52258 13.6506 5.90471C13.7774 7.44423 13.3018 8.97288 12.3239 10.1687L9.12859 14.076C8.99185 14.2433 8.81965 14.378 8.62445 14.4705C8.42926 14.5631 8.21594 14.6111 7.99993 14.6111C7.78391 14.6111 7.57059 14.5631 7.3754 14.4705C7.1802 14.378 7.00801 14.2433 6.87126 14.076L3.67593 10.1687C2.698 8.97292 2.22238 7.44424 2.34926 5.90471ZM7.85593 1.83337C6.72025 1.83355 5.62615 2.26073 4.79081 3.03012C3.95546 3.79952 3.43995 4.85487 3.34659 5.98671C3.24099 7.26795 3.63678 8.54016 4.45059 9.53537L7.64593 13.4434C7.68888 13.4959 7.74298 13.5383 7.80432 13.5674C7.86566 13.5965 7.9327 13.6116 8.00059 13.6116C8.06848 13.6116 8.13552 13.5965 8.19686 13.5674C8.2582 13.5383 8.3123 13.4959 8.35526 13.4434L11.5506 9.53537C12.3639 8.53997 12.7592 7.26777 12.6533 5.98671C12.5599 4.85476 12.0443 3.79931 11.2088 3.02989C10.3733 2.26048 9.27905 1.83338 8.14326 1.83337H7.85526H7.85593Z"
                      fill="#888888"
                    />
                  </svg>{" "}
                  {hotelData?.hotelInfo?.address}
                </small>
              </GetDirectionRedirect>

              <p className="font_12">{hotelData?.hotelInfo?.details}</p>
              <SingleHotelCard
                rooms={hotelData}
                bookingData={bookingData}
                agentDiscount={agentDiscount}
              />
            </div>
          </div> */
}
